export function PageWatermark({ variant = "light" }) {
  const isAuth = variant === "auth";
  return (
    <div
      className="fixed inset-0 flex items-center justify-center pointer-events-none overflow-hidden z-0"
      aria-hidden="true"
      data-testid="page-watermark"
    >
      <img
        src="/igc-watermark.webp"
        alt=""
        className={isAuth ? "w-[70vw] max-w-[900px] opacity-[0.16] select-none" : "w-[65vw] max-w-[820px] opacity-[0.11] select-none"}
        style={isAuth ? undefined : { filter: "brightness(0.55) contrast(1.15)" }}
        draggable="false"
      />
    </div>
  );
}
